import { Service } from '@piwikpro/platform';

@Service()
export class InternalServerError extends Error {
  name = 'InternalServerError';

  errors = {};
}
